package com.patronat.top.features.usermanagement.presentation.mappers

import com.patronat.top.core.domain.models.profiles.User
import com.patronat.top.dto.UserStatus
import com.patronat.top.features.usermanagement.presentation.create.CreateOrUpdateUserState

fun CreateOrUpdateUserState.toDomainModel(): User {
    return User(
        id = this.userId,
        phone = this.phone,
        email = this.email,
        firstName = this.firstName,
        lastName = this.lastName,
        role = this.role,
        status = if (this.status
            == UserStatus.ACTIVE)
            UserStatus.ACTIVE else UserStatus.DEACTIVATED,
        avatarUrl = this.avatarUrl,
        avatarMediaId = this.avatarMediaId,
        )
}